import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './styles/SB-Admin-2.css';
import './styles/Dashboard.css';
import App from './App';

// Determine router basename dynamically
// Priority:
// 1) Explicit env var REACT_APP_ROUTER_BASENAME
// 2) Auto-detect from pathname if starts with /smartlms
// 3) Fallback to '/'
const computeBasename = () => {
  const explicit = process.env.REACT_APP_ROUTER_BASENAME;
  if (explicit && explicit.trim()) return explicit.trim();
  
  // Auto-detect subpath from current URL
  if (typeof window !== 'undefined' && window.location.pathname.startsWith('/smartlms')) {
    return '/smartlms';
  }
  
  return '/';
};

const routerBasename = computeBasename();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter basename={routerBasename}>
      <App />
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </BrowserRouter>
  </React.StrictMode>
);
